<template>
  <img
    ref="imgRef"
    :alt="alt"
    :class="{ loaded: isLoaded }"
  />
</template>

<script setup>
import { ref, onMounted, defineProps, onBeforeUnmount } from 'vue'

const props = defineProps({
  src: String,
  alt: {
    type: String,
    default: ''
  }
})

const imgRef = ref(null)
const isLoaded = ref(false)

let observer = null

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        imgRef.value.src = props.src

        imgRef.value.onload = () => {
          isLoaded.value = true
        }

        observer.unobserve(entry.target)
      }
    })
  }, {
    rootMargin: '100px'
  })

  observer.observe(imgRef.value)
})

onBeforeUnmount(() => {
  if (observer) observer.disconnect()
})
</script>

<style scoped>
  img {
    width:100%;
    height:220px;
    object-fit:cover;
    border-radius:16px;
    opacity:0;
    transition: opacity .6s ease;
  }

  img.loaded {
    opacity:1;
  }
</style>